import { useContext } from "react"
import { useRouteMatch } from "react-router-dom"
import ReactMarkdown from "react-markdown"

import questionsContext from '../../context/questions'

import PageNotFound from '../PageNotFound'
import { getQuestionFromSlug } from '../../functions/questions'


function Single({ title, description, content, newQuestion }) {
    const questions = useContext(questionsContext)
    const { params } = useRouteMatch()
    let question

    if (title === undefined) {
        const question_slug = params.id

        question = getQuestionFromSlug(questions, question_slug)

        title = question?.title
        description = question?.description
        content = question?.content
    }
    document.title = title

    if (title === undefined)
        return <PageNotFound msj="No such question found!" />

    const styleForDiv = newQuestion ? {} : { maxWidth: '1100px' }

    return <>
        {/* TODO: Have to change class names */}
        <section id="main" className="content-pad">
            <div className={"content-wrapper in-modal " + (newQuestion ? 'center' : '')} style={styleForDiv}>
                <h1 id="title" className="snippet-title">
                    {title}
                </h1>
                {/* TODO: Have to add here description */}
                {/* TODO: Have to add here tags */}

                <div>
                    <article id="content">
                        <ReactMarkdown>
                            {content}
                        </ReactMarkdown>
                    </article>
                </div>
            </div>
        </section>
    </>
}


export default Single
